<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'Research',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <section class="support--container">
      <video
        class="fullscreen"
        src="https://vanished-fe.s3.us-east-2.amazonaws.com/Error_2+2..mp4"
        playsinline
        autoplay
        muted
        loop
      >
      </video>

      <div class="content">
        <div id="load-content">
          <img
            src="https://vanished-fe.s3.us-east-2.amazonaws.com/mantle-w-2.png"
          />
          <h3> Found an issue or need support? </h3>
          <a href="mailto:support@vanished.industries">
            <a-button icon="mail"> Email Us </a-button>
          </a>
        </div>
      </div>
    </section>
  </Layout>
</template>

<style lang="scss">
@import '@design';

.support--container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  background: white;
  h3 {
    color: white;
  }

  video.fullscreen {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: #141414;
    background-position: center;
    background-size: cover;
    transition: 0.2s ease-in-out;
    transform: translate(-50%, -50%);
    object-fit: cover;

    &::-webkit-media-controls {
      display: none !important;
    }
  }

  .container {
    position: relative;
    display: grid;
    width: 70vw;
    height: 70vh;
    margin: 0 auto;
    place-items: center;
  }

  .content {
    z-index: 1;

    #load-content {
      text-align: center;
      img {
        display: block;
        width: 300px;
        margin: 0 auto;
        margin-bottom: 2rem;
      }
      h5 {
        margin-bottom: 2rem;
        color: white;
      }
    }
  }
}
</style>
